/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import moment from 'moment';
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';

const FilterModal = ({filterModal,setFilterModal, Filter, setFilter, handlePendingOrderReports, SetSuccessMessage, selected, setselected,setfilterValue, filterValue}) => {
    const dateRef = useRef();
    const orderTypes = ['Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'];
    const [selectedType, setselectedType] = useState('order_type');
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const HandleFilter=useCallback((key,val)=>{
        const Filtercopy={...Filter};
        const idx=Filtercopy[key].indexOf(val);
        if(idx=== -1){
            Filtercopy[key].push(val)
        }else{
            Filtercopy[key].splice(idx,1)
        }
        Filtercopy[key]
        setFilter(Filtercopy)
        return idx>-1
        // return false   
    },[])

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length > 0) {
                    final += `&order_type=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date_range=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handlePendingOrderReports(final);
        }
        setfilterValue(final);
        setFilterModal(false);
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
        return final;
    };

    const handleClear = ()=>{
        setFilter({
            order_type:[],
        })
        setselected({ start_date: '', end_date: '' });
        setfilterValue('')
        handlePendingOrderReports() 
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);     
    }

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed ${filterModal ? 'show' : 'hidden'} top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[575px] mx-auto px-2.5" style={{ margin : 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[14px] rounded-t-md">
                        <h5 className="sm:text-xs4 text-lg font-semibold text-[#555259] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button 
                            type="button" 
                            className="absolute top-4 right-6" 
                            data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={() =>setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" className="w-3.5 h-3.5"/>
                        </button>
                    </div>
                    <div className="modal-body relative sm:pl-5 pr-7 px-3 sm:pt-5 pt-4 pb-[18px] text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={()=>setselectedType('order_type')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selectedType==='order_type' ? 'active' :''} order relative w-full`} id="pills-ordercategory" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"   aria-controls="pills-pricetab" aria-selected="true">
                                        Order Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={()=>setselectedType('order_date')}>
                                    <a href="javascript:void(0)" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selectedType==='order_date' ? 'active' :''} order relative w-full`} id="pills-daterangetab" data-bs-toggle="pill" data-bs-target="#pills-daterange" role="tab"
                                        aria-controls="pills-daterange" aria-selected="false">
                                        Order Date
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[198px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType==='order_type'?'show active':''} fade px-3 h-[198px] overflow-auto custom-scrollbar1`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-ordercategory">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {orderTypes.map((order, orderIndex) => (
                                                <div className="flex items-center mb-3" key={`type-${orderIndex}`}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes(order) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.order_type?.includes(order)}
                                                        onChange={() => HandleFilter('order_type', order)}
                                                        borderColor={`${Filter.order_type?.includes(order) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={order}
                                                    />
                                                    <label htmlFor={order} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {order}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef} className={`tab-pane ${selectedType==='order_date'?'show active':''} fade px-3`} id="pills-daterange" role="tabpanel" aria-labelledby="pills-daterangetab">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="From date"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.start_date && (
                                                <Calendar
                                                    value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                                    onChange={(val) => handleDate(val, 'start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && <Calendar value={selected.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-4">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={()=>handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={()=>generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterModal
